import styled from "styled-components";
const AccordionItemWrapper = styled("div")({});
const AccordionItemButton = styled("button")(({ theme }) => ({
  background: "none",
  border: 0,
  borderRadius: 2,
  color: theme.color.default,
  cursor: "pointer",
  fontSize: theme.fontSize.default,
  lineHeight: theme.lineHeight.default,
  outline: 0,
  padding: "0 4px",
  width: "100%",
  "&:hover": {
    backgroundColor: theme.color.gray2
  },
  "&:active": {
    backgroundColor: theme.color.gray4
  },
  "&:focus": {
    boxShadow: `0 0 0 2px ${theme.color.gray3}`
  }
}));
const AccordionItemContent = styled("div")({});
const AccordionItemContentInner = styled("div")({
  paddingTop: 2,
  paddingBottom: 10,
  "p:last-child": {
    marginBottom: 0
  }
});
export {
  AccordionItemButton,
  AccordionItemContent,
  AccordionItemContentInner,
  AccordionItemWrapper
};
